// ============================================================================
// shared/ui/Input.tsx — Input controlado por react-hook-form (reemplaza .form-control).
// forwardRef para que el spread {...register("campo")} siga funcionando (§B.3).
// Nota: la regla global `input { text-transform:uppercase; font-size:14.4px }`
// (public/css/styles.css) sigue aplicando; este primitivo no la anula.
// ============================================================================
import { forwardRef } from "react";
import type { InputHTMLAttributes } from "react";

type InputProps = InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className = "", ...rest }, ref) => (
    <input
      ref={ref}
      className={`tw-block tw-w-full tw-rounded tw-border tw-border-gray-300 tw-px-2 tw-py-1 tw-text-sm focus:tw-outline-none focus:tw-border-primario focus:tw-ring-1 focus:tw-ring-primario ${className}`}
      {...rest}
    />
  ),
);
Input.displayName = "Input";
